import { render, staticRenderFns } from "./oilAndGasConsume.vue?vue&type=template&id=4c157066&scoped=true&"
import script from "./oilAndGasConsume.vue?vue&type=script&lang=js&"
export * from "./oilAndGasConsume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c157066",
  null
  
)

export default component.exports